/** End a rejected session consistently for HTTP requests and socket connections. */
export const expireSession = () => {
    for (const key of ['authToken', 'userRole', 'userName', 'userId', 'usersDirectory']) {
        localStorage.removeItem(key);
    }
    window.location.assign('/login');
};
